import { cn } from "@/lib/utils";

interface Props {
  children: React.ReactNode;
  bg?: string;
  text?: string;
  className?: string;
}

export function Badge({ children, bg = "bg-gray-100", text = "text-gray-800", className }: Props) {
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded text-xs font-medium", bg, text, className)}>
      {children}
    </span>
  );
}
